module.exports = __webpack_public_path__ + "img/arrow-right-square-fill.fca45ce5.svg";